import React, { Component } from 'react';
import { Redirect, Route } from 'react-router';
import { Layout } from './components/Layout/Layout';

import { WelcomePage } from './components/Welcome/Welcome';
import { AskAccess } from './components/AskAccess/AskAccess';
import { LoginComponent } from './components/LoginComponent/LoginComponent';
import { CreateAccountPage } from './components/LoginComponent/CreateAccountPage';
import { ConfirmPage } from './components/LoginComponent/ConfirmPage';
import { ResetPWPage } from './components/LoginComponent/ResetPWPage';
import { ExternalConsent } from './components/LoginComponent/ExternalConsent';
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { Common } from './components/LoginComponent/Common';
import {SubmitAgreement} from './components/SubmitAgreement/SubmitAgreement';
import {DocumentSearchAndDownload} from './components/DocumentSearchAndDownload/DocumentSearchAndDownload';
import './custom.scss'
import DataProvider from './dataprovider/DataProvider';

import { CookieList } from './components/LoginComponent/CookieList';


export const PageURL = {
    Welcome: "/",
    ConfirmationPage: "/confirm",
    ResetPWPage: "/resetPW",
    Consent: "/consent",
    CookieList: "/cookies",
    CreateAccount: "/create-account",
    AskAccess:"/AskAccess",
    SubmitAgreement:"/SubmitAgreement",
    Download:"/Download"
}


function getMSALConfig(){
    let returnURI = Common.getCurrentServerUrl();
  
    return  {
        auth: {
            clientId: "616b6cae-69cb-4a9b-9674-d6ab4ef29376",
            authority: "https://login.microsoftonline.com/common",
            redirectUri: `${returnURI}`
        },
        cache: {
            cacheLocation: "sessionStorage", // This configures where your cache will be stored
            storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
        }
    };
}

const msalInstance = new PublicClientApplication(getMSALConfig());


export default class App extends Component {
    refLoginComponent = null;

    constructor() {
        super();

        let isLoggedIn = false;
        let currentUser = null;

        if (window.sessionStorage.authToken) {
            try {
                let authToken = JSON.parse(window.sessionStorage.authToken);
                let expirationDate = new Date(authToken.expirationUTC);
                if (expirationDate < new Date()) {
                    // this token is expired. Clean it up
                    window.sessionStorage.removeItem("authToken");
                    window.sessionStorage.removeItem("stlUser");
                    alert("Your Session expired. Please sign-in again.");
                } else if (window.sessionStorage.stlUser) {
                    currentUser = JSON.parse(window.sessionStorage.stlUser);
                    isLoggedIn = true;
                }
            } catch (e) {
                console.error("Error reading auth token from sessionStorage", e);
            }
        }

        this.state = {
            isLoggedIn: isLoggedIn,
            currentUser: currentUser,
            path: "/",
            redirectHome: false
        };

        this.refLoginComponent = React.createRef();
    }    

    componentDidMount() {
        // Auth state loaded synchronously in the constructor to prevent redirect race conditions
    }

    setAuthStatus = (loggedIn, user, redirectAfterLogout = true) => {

        return new Promise((resolve, reject) => { 
            if (!loggedIn || !user) {
                sessionStorage.removeItem("authToken");
                sessionStorage.removeItem("stlUser");

                this.setState({ isLoggedIn: false, currentUser: null }, () => {
                    if (redirectAfterLogout) {
                        window.location.assign(`${window.location.protocol}//${window.location.host}`);
                    }

                    resolve();
                });

                return;
            }

            if (user.bearerToken) {
                sessionStorage.setItem("authToken", JSON.stringify(user.bearerToken));
            } else {
                sessionStorage.removeItem("authToken");
            }

            sessionStorage.setItem("stlUser", JSON.stringify(user));

            this.setState({ isLoggedIn: loggedIn, currentUser: user }, () => {
                resolve();
            });
            console.log("%cCurrent User", "color:blue;font-size:16px", user);
        });
    }

    sessionExpired = () => {
        this.setState({
            isLoggedIn: false,
            currentUser: null
        });
        window.sessionStorage.removeItem("authToken");
        window.sessionStorage.removeItem("stlUser");
        alert("Your Session expired. Please sign-in again.");
    };

    static displayName = App.name;

    dataProvider = new DataProvider(); 

    renderProtectedRoute = (ComponentToRender, extraProps = {}) => {
        return (props) => {
            if (!this.state.isLoggedIn) {
                return <Redirect to="/" />;
            }

            return <ComponentToRender sessionExpired={this.sessionExpired} currentUser={this.state?.currentUser} {...props} isLoggedIn={this.state.isLoggedIn} dataProvider={this.dataProvider} {...extraProps} />;
        };
    }


    render() {
        const currentPath = window.location.pathname.toLowerCase();

        return (            
            <Layout
                headerRightContent={
                    <LoginComponent
                        key={`header-${currentPath}`}
                        setAuthStatus={this.setAuthStatus}
                        currentUser={this.state?.currentUser}
                        headerAccountOnly={true}
                    />
                }
            >
                {this.state.redirectHome && <Redirect to="/"/>}
                <MsalProvider instance={msalInstance}>
                    <Route exact path='/' render={(props) => {
                        return <WelcomePage {...props} dataProvider={this.dataProvider} currentUser={this.state?.currentUser} isLoggedIn={this.state.isLoggedIn} setAuthStatus={this.setAuthStatus} />;
                            
                    }} />  
                    <Route exact
                        path={PageURL.CreateAccount}
                        render={(props) => {
                            return <CreateAccountPage {...props} dataProvider={this.dataProvider} />;
                        }}
                    />
                    <Route exact
                        path={PageURL.ConfirmationPage}
                        render={(props) => {
                            return <ConfirmPage {...props} dataProvider={this.dataProvider} />;
                        }}
                    />                  
                     {/* {<Route exact
                        path={PageURL.SubmitAgreement+"/:id"}
                        render={this.renderProtectedRoute(SubmitAgreement)}
                    />} */}
                    <Route exact
                        path={PageURL.ResetPWPage}
                        render={(props) => {
                            return <ResetPWPage {...props} dataProvider={this.dataProvider} />;
                        }}
                    />
                        <Route exact
                        path={PageURL.AskAccess}                    
                        render={this.renderProtectedRoute(AskAccess)}
                        />
                         <Route exact
                        path={PageURL.Download}                    
                        render={this.renderProtectedRoute(DocumentSearchAndDownload)}
                        />
                    <Route exact
                        path={PageURL.Consent}
                        render={(props) => {
                            if (!window.sessionStorage.rsmConsentTarget) {
                                return <Redirect to="/" />;
                            }
                            return <ExternalConsent setAuthStatus={this.setAuthStatus} loginComponent={this.refLoginComponent.current} {...props} />;
                        }
                        }/>
                    <Route exact 
                        path={PageURL.CookieList} 
                        render={(props)=>{
                            return <CookieList {...props} />;
                        }}
                        />
                    <div style={{ height: '100%' }}><LoginComponent key={currentPath} ref={ this.refLoginComponent } setAuthStatus={this.setAuthStatus} currentUser={this.state?.currentUser} hideUnauthenticatedControls={currentPath === "/" || currentPath === PageURL.CreateAccount.toLowerCase()} hideAuthenticatedControls={true} /></div>
                </MsalProvider>
            </Layout>            
        );
    }
}
